export default {"src":"/_next/static/media/student-avatar.bbe925f9.svg","height":120,"width":120};